import type { ReactNode } from "react"

interface LinksProps {
  children: Readonly<ReactNode>
}

export default function Links({ children }: LinksProps) {
  return (
    <div className="hidden w-full items-center justify-center gap-8 md:flex">
      {children}
    </div>
  )
}


import Link from "next/link"

interface LinkItemProps {
  label: string
  link: string
}

export function LinkItem({ label, link }: LinkItemProps) {
  return (
    <Link
      href={link}
      className="font-semibold hover:opacity-95 active:opacity-90"
    >
      {label}
    </Link>
  )
}
